import React from 'react';
import Footer1 from '../components/Footer1';
import Header1 from '../components/Header1';
import PageBanner from '../components/PageBanner';
import ServiceSidebar from '../components/ServiceSidebar';
import ServiceContactForm from '../components/ServiceContactForm';
import { SRLWrapper } from 'simple-react-lightbox';
import img1 from '../assets/img/gallery/5.jpg';
import img2 from '../assets/img/gallery/6.jpg';
import FaqAccordion from '../components/FaqAccordion';

function CadDesignService() {
    const bannerBg = '/service-hero-bg.jpg';

    return (
        <>
            <Header1 />
            <PageBanner
                bannerBg={bannerBg}
                heading="CAD Design & 3D Scanning"
                currentPage="CAD Design & 3D Scanning"
            />
            <section className="service-details-wrapper section-padding">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-3 col-md-4 mt-5 mt-md-0 col-12 order-2 order-md-1">
                            <ServiceSidebar />
                        </div>
                        <div className="col-lg-9 col-md-8 col-12 order-1 order-md-2">
                            <div className="service-details-content-wrapper pl-0 pl-md-4">
                                <h2>Comprehensive Design & Development Process</h2>
                                <p>
                                    From initial concept to fully validated designs, ProtoPath delivers complete CAD design and
                                    3D scanning services. Our systematic approach ensures your ideas are transformed into precise,
                                    manufacturable solutions. We guide you through every phase: Concept → Detail Designing → Validation,
                                    ensuring optimal results at each stage.
                                </p>

                                <h2>Professional CAD Design Services</h2>
                                <p>
                                    Our experienced engineering team creates detailed 2D technical drawings and 3D CAD models using
                                    industry-leading software. We specialise in mechanical design, product development, and assembly
                                    documentation that meets Australian standards and international specifications. Whether you need
                                    initial concept sketches or production-ready engineering drawings, we deliver precision and accuracy
                                    tailored to your manufacturing requirements.
                                </p>

                                {/* <SRLWrapper>
                                    <div className="row">
                                        <div className="col-md-6 col-12">
                                            <a href={img1} className="popup-gallery">
                                                <img src={img1} alt="CAD Design & Technical Drawings" />
                                            </a>
                                        </div>
                                        <div className="col-md-6 col-12">
                                            <a href={img2} className="popup-gallery">
                                                <img src={img2} alt="3D Scanning & Modeling" />
                                            </a>
                                        </div>
                                    </div>
                                </SRLWrapper> */}

                                <h2>Advanced 3D Scanning & Prototyping</h2>
                                <p>
                                    Our state-of-the-art 3D scanning technology captures existing components with exceptional precision,
                                    perfect for reverse engineering, quality control, and creating digital twins. Combined with our
                                    3D printing capabilities, we can rapidly produce physical prototypes directly from scanned data or
                                    CAD models. This integrated approach accelerates your product development cycle, allowing for quick
                                    design iterations and validation before committing to full-scale production.
                                </p>

                                <blockquote>
                                    Transform your concepts into reality with our integrated design workflow - from initial sketches
                                    to validated prototypes, we provide the complete solution for your product development needs.
                                </blockquote>

                                <div className="faq-content pl-0 pl-md-4 mt-5">
                                    <h2>Our Design Process</h2>
                                    <FaqAccordion
                                        question="Concept Development"
                                        answer="Initial consultation to understand your requirements, followed by conceptual sketches and preliminary designs that explore different approaches and solutions."
                                    />
                                    <FaqAccordion
                                        question="Detail Design & Engineering"
                                        answer="Creation of comprehensive 2D technical drawings and 3D CAD models with full specifications, tolerances, and manufacturing details ready for production."
                                    />
                                    <FaqAccordion
                                        question="Validation & Prototyping"
                                        answer="Design validation through 3D scanning verification, prototype production via 3D printing, and iterative refinement to ensure optimal performance before manufacturing."
                                    />
                                </div>

                                <ServiceContactForm serviceName="CAD Design & 3D Scanning" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer1 />
        </>
    );
}

export default CadDesignService;
